// JavaScript source code
import React, { useEffect, useState } from 'react';
import {  useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import dataSubBanner from '../assets/fake-data/data-subbanner';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import { getUser } from '../request';
import LoginDialog from '../components/loginDialog';
function IncrementService(props) {
    let activeIndex = 4;
    let activeSubIndex = 4;
    const theData = dataSubBanner.filter(item => {
        return item.id == activeSubIndex;
    })[0];
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (      
        <div className={`aboutUs ${theData.titleClass}`} >
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>
                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail">{theData.pageDetail}</div>
                </div>
                <div className="subcontent">
                {
                        screenSize > 991 ? (
                            <div>
                                <img src={theData.imgList[0]} />
                                <img src={theData.imgList[1]} />
                            </div>) :
                    (
                                <div>
                                    <img src={theData.mimgList[0]} />
                                    <img src={theData.mimgList[1]} />
                            </div>
                    )

                }
                </div>
            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>
          
    );
}

export default IncrementService;